export default __webpack_public_path__ + "static/breadcrumbs-current-item-do-dark-5b132e3496806b9a046321f4add9c8d7df947cd4214a764a85b0e61ae4c42d20.png";